/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import {
  CompaniesDto,
  MenuAnchorEl,
  ROUTES,
  TUTORIAL_IDS
} from "../../../../../../shared";
import Menu from "../../../../../Menu/Menu";
import CompanySelectorContent from "../CompanySelectorContent/CompanySelectorContent";

interface IDesktopCompanySelectorProps {
  route: ROUTES;
  anchorEl: MenuAnchorEl;
  companies: CompaniesDto[];
  onClose: () => void;
}

const DesktopCompanySelector = ({
  route,
  anchorEl,
  companies,
  onClose
}: IDesktopCompanySelectorProps) => {
  return (
    <Menu
      data-testid="desktop-company-selector"
      id="desktop-company-selector"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{
        paper: {
          id: TUTORIAL_IDS.CompanySelectorMenu
        }
      }}
      css={css({
        "& .MuiPaper-root": [
          {
            width: "566px"
          }
        ]
      })}
    >
      <CompanySelectorContent
        route={route}
        companies={companies}
        close={onClose}
      />
    </Menu>
  );
};

export default DesktopCompanySelector;
